import React, { useEffect, useContext } from "react";
import { Segment, Tab } from "semantic-ui-react";
import EditCompanyForm from "./EditSupplierForm";
import TributaryInformation from "./TributarySupplier";
import PhotoUploadWidget from "../../../../app/common/photoUpload/PhotoUploadWidget";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import SwDian from "./SwDian";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import Integration from "./Integration";
import EmailConfig from "./EmailConfig";

interface IProps {
  sections: any[];
}

const Company: React.FC<IProps> = ({ sections }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { loadSupplier } = rootStore.companyStore;
  const {
    getPartyTax,
    getTaxLevelName,
    getTaxLevelCode,
  } = rootStore.listOfValours;

  useEffect(() => {
    getTaxLevelCode();
    getPartyTax();
    getTaxLevelName();
  }, [getPartyTax, getTaxLevelCode, getTaxLevelName]);

  const panes = [
    {
      menuItem: "Datos de la Empresa",
      render: () => (
        <Tab.Pane>
          <EditCompanyForm />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Información tributaria",
      render: () => (
        <Tab.Pane>
          <TributaryInformation />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Logo",
      render: () => (
        <Tab.Pane>
          <PhotoUploadWidget />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Datos DIAN",
      render: () => (
        <Tab.Pane>
          <SwDian />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Integración",
      render: () => (
        <Tab.Pane>
          <Integration />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Notificaciones",
      render: () => (
        <Tab.Pane>
          <EmailConfig />
        </Tab.Pane>
      ),
    },
  ];

  document.title = "Configuración-Mi empresa";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Mi empresa"
        sections={sections}
      />
      <Segment>
        <div className="configurationContent">
          {!loadSupplier ? (
            <LoadingComponent content="Cargando informacíon" />
          ) : (
            <Tab panes={panes} />
          )}
        </div>
      </Segment>
    </div>
  );
};

export default observer(Company);
